import { Component, EventEmitter, Output, inject, input, signal } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { AppStore } from 'src/app/core/app.store'
import { BreadcrumbRouterComponent } from 'src/app/shared/components/breadcrumb/breadcrumb-router/breadcrumb-router.component'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { HeaderTogglerDirective } from 'src/app/shared/components/header/header-toggler/header-toggler.directive'
import { SidebarToggleDirective } from 'src/app/shared/components/sidebar/sidebar-toggle.directive'
import { NgxPermissionsModule } from 'ngx-permissions'
import { AiChatPanelComponent } from 'src/app/shared/components/ai-chat-panel/ai-chat-panel.component'
import { AiChatPanelService } from 'src/app/core/services/ai/ai-chat-panel.service'

@Component({
    selector: 'sf-header',
    imports: [
        NgbTooltipModule,
        NgxPermissionsModule,
        NgbDropdownModule,
        ReactiveFormsModule,
        ButtonComponent,
        FontAwesomeModule,
        BreadcrumbRouterComponent,
        HeaderTogglerDirective,
        SidebarToggleDirective,
        AiChatPanelComponent,
    ],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    host: {
        class: 'header header-sticky p-0 mb-4',
    },
})
export class HeaderComponent {
    appStore = inject(AppStore)
    #aiChatPanelService = inject(AiChatPanelService)
    sidebarId = input('sidebar1')

    @Output()
    menuToggle = new EventEmitter()

    showExtendedSettings = signal(false)
    showAiPanel = this.#aiChatPanelService.isPanelOpen
    initialPrompt = this.#aiChatPanelService.initialPrompt

    toggleAiPanel(): void {
        if (this.showAiPanel()) {
            this.#aiChatPanelService.closePanel()
        } else {
            this.#aiChatPanelService.openPanel()
        }
    }

    closeAiPanel(): void {
        this.#aiChatPanelService.closePanel()
    }

    toggleMenu(): void {
        this.menuToggle.emit()
    }
}
